module.exports = "https://mrkt.spotifycdn.com/artists-spotify-com/_next/static/images/artist-f639614fd322accf0dd0fc36e74851e0.png";